import { useHasRole } from '@app/core/auth/authorization/hooks/useHasRole';
import { Device, UserRole } from '@mi-front/core';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { apiClient } from '../../../../../api';

/**
 * React Query hook to fetch all streamer box devices.
 * Only fetches if user is not a basic user (CLIENT_USER).
 */
export function useStreamerBoxDevices(): UseQueryResult<readonly Device[], Error> {
  const isBasicUser = useHasRole(UserRole.CLIENT_USER);

  return useQuery<readonly Device[]>({
    queryKey: useStreamerBoxDevices.queryKey(),
    queryFn: () => apiClient.streamerBox.fetchDevices(),
    enabled: !isBasicUser,
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}

/**
 * Query key factory for streamer box devices query.
 */
useStreamerBoxDevices.queryKey = () => ['streamerBox', 'devices'] as const;
